import React from 'react';
import logoImage from '../assets/Logo_1.png';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md', variant = 'dark' }) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'h-12 w-auto';
      case 'md':
        return 'h-16 w-auto';
      case 'lg':
        return 'h-12 w-auto';
      default:
        return 'h-10 w-auto';
    }
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoImage} 
        alt="Pari567" 
        className={`${getSizeClasses()} object-contain`}
      />
    </div>
  );
};

export default Logo;
